// extracted by mini-css-extract-plugin
export default {"content":"beerListContainer_content__Qwdr2","newBeerButton":"beerListContainer_newBeerButton__aURhk"};